import React from 'react'
import { Container, Icon, Link, TextBody } from '@pdrj/pmi-iqos-ds-react'

const SpotsStoreLink = ({
  spot,
  translations,
  'data-testing-prefix': dataTestingPrefix
}) => {
  return spot && spot.website ? (
    <Container display={Container.displays.flex}>
      <Container pr="2">
        <Icon size={Icon.sizes.xs} image={Icon.images.outsideLink} />
      </Container>
      <TextBody>
        <Link
          href={spot.website}
          data-testing={dataTestingPrefix + '_Link_StoreHomepage'}>
          {translations.tk_goToStoreHomepage}
        </Link>
      </TextBody>
    </Container>
  ) : null
}

export default SpotsStoreLink
